import React, { memo } from "react";
import { UncontrolledTooltip } from "reactstrap";

const BASE_STYLE = {
    fontSize: "10px",
    fontWeight: 700,
    padding: "3px 8px",
    borderRadius: "7px",
    whiteSpace: "nowrap",
    width: "fit-content",
    display: "inline-block",
    textAlign: "center",
};

/**
 * Shared status badge for asset / compliance / CE conformity statuses.
 *
 * Pass either `backgroundColor` (hex/css) or `color` (bootstrap color name
 * used as `bg-${color}`). Titles and colors stay caller-controlled; layout
 * styles stay consistent.
 */
const StatusBadge = ({
    label,
    backgroundColor,
    color,
    textColor = "#1D1D1D",
    opacity = 1,
    id,
    tooltip,
    className = "",
    emptyFallback = "---",
}) => {
    if (!label) {
        return emptyFallback;
    }

    const style = {
        ...BASE_STYLE,
        opacity,
        color: textColor,
        ...(backgroundColor ? { background: backgroundColor } : {}),
    };

    const classes = [
        "dt-task-status",
        color ? `bg-${color}` : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <>
            <span id={id} style={style} className={classes}>
                {label}
            </span>

            {id && tooltip ? (
                <UncontrolledTooltip target={id} trigger="hover">
                    {tooltip}
                </UncontrolledTooltip>
            ) : null}
        </>
    );
};

export default memo(StatusBadge);
